/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Feed item
 * @author Mark VanDeWeghe
 */

import React, { memo } from "react";
import { SiteImage } from "../SiteImage";
import { IResource } from "../../types";
import { StringResource } from "../StringResource";
import { getKeyedString } from "../../api/get-string";

interface IProps {
	resource: IResource;
}

export const FeedItem = memo((props: IProps) => {
	const { resource } = props;
	const { key, image, url } = resource;

	return (
		<>
			<div className="card-item resource">
				<div className="resource-icon">
					<SiteImage localPath={"custom/images/" + image} />
				</div>
				<div className="resource-content">
					<a className="resource-content-link" href={url}>
						<StringResource
							raw={getKeyedString(
								StringResources.covidtriage.ResourceTitle,
								key as string,
							)}
						/>
					</a>
					<span className="resource-content-text" aria-hidden="true">
						<StringResource
							raw={getKeyedString(
								StringResources.covidtriage.ResourceBody,
								key as string,
							)}
						/>
					</span>
				</div>
			</div>
		</>
	);
});
